/* Glowny – efeitos do botão de compra (Soft Press + Liquid Glass Touch) */
(function () {
  function enhance(button) {
    if (button.dataset.glowny === '1') return;
    button.dataset.glowny = '1';
    var glass = document.createElement('span');
    glass.className = 'glowny-glass';
    glass.setAttribute('aria-hidden', 'true');
    button.appendChild(glass);

    function position(event) {
      var rect = button.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      glass.style.setProperty('--gx', x + '%');
      glass.style.setProperty('--gy', y + '%');
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    }

    button.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'mouse') position(event);
    });
    button.addEventListener('pointerdown', function (event) {
      var point = position(event);
      button.classList.add('glowny-pressed');
      var drop = document.createElement('span');
      drop.className = 'glowny-glass__drop';
      drop.style.setProperty('--dx', point.x + 'px');
      drop.style.setProperty('--dy', point.y + 'px');
      glass.appendChild(drop);
      drop.addEventListener('animationend', function () { drop.remove(); });
    });
    ['pointerup', 'pointerleave', 'pointercancel', 'blur'].forEach(function (name) {
      button.addEventListener(name, function () { button.classList.remove('glowny-pressed'); });
    });
  }

  function init() {
    document.querySelectorAll('.main-product-atc').forEach(enhance);
  }

  init();
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Checkout Yampi: o app da Yampi só assume o checkout na página /cart (ela redireciona para seguro.useglowny.com.br).
   O botão "Finalizar" do carrinho lateral abria o checkout nativo do Shopify, então levamos o cliente para /cart. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn || /^\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = '/cart';
  }, true);
})();
